module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-arrow-u-d8bb84ffdd2897405f62ebd629993703.svg";